import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=b3a60552&"
import script from "./CampaignsList.vue?vue&type=script&lang=js&"
export * from "./CampaignsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports